import React from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';

const DragHandle = SortableHandle(() =>
  <i className="zmdi zmdi-menu fa fa-arrows-alt fa-rotate-45 dragger" />);

class UpdateLayoutt extends React.Component {
  render() {
    const { contact } = this.props;
    const { name, thumb } = contact;
    return (
      <div className="col-4 contact-item ripple row no-gutters align-items-center py-2 px-3 py-sm-4 px-sm-6 drag-border">
        <div className="col-12">
          <div className="position-absolute cursor-pointer">
            <DragHandle />
          </div>
          <div className="text-center text-white" style={{ fontSize: 10 }}>
            <img className="size-40" alt={name} src={thumb} />
            <div className="font-weight-bold">{name}</div>
          </div>
        </div>
      </div>
    );
  }
}
export default SortableElement(UpdateLayoutt);



// WEBPACK FOOTER //
// ./app/routes/components/routes/AdminPanel/LayoutCell/index.js